import React from 'react';
import styled from 'styled-components';

import { Icon } from '@ui/icons/Icon.tsx';
import Tooltip from '@ui/tooltip';

import { handleKeyboardSelect } from '../../../plugins/utils/keyboardUtils.ts';
import { isRtl } from '../../utils/dom.ts';

const CloseButtonWrapper = styled.button`
  cursor: pointer;
  border: none;
  background-color: var(--color-background);
  && {
    margin-block: 0;
    margin-inline: auto 0;
  }
`;

const BackButtonWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: var(--color-secondary);
`;

const StyledTooltip = styled(Tooltip)`
  margin-inline-start: auto;
`;

type ModalControlProps = {
  color: string;
  onClick: () => void;
  text?: string;
  tooltipText?: string;
};

const CloseButton = ({ onClick, color, tooltipText }: ModalControlProps) => {
  const resolvedTooltipText = tooltipText || 'Close';
  return (
    <StyledTooltip text={resolvedTooltipText} arrowPosition="left">
      <CloseButtonWrapper
        type="button"
        onClick={onClick}
        aria-label={resolvedTooltipText}
        tabIndex={0}
        onKeyDown={handleKeyboardSelect(() => {
          onClick();
          document.getElementById('tooltip')?.setAttribute('style', 'display: none;');
        })}
      >
        <Icon name="close" cdn width={32} height={32} fillColor={color} />
      </CloseButtonWrapper>
    </StyledTooltip>
  );
};

const BackButton = ({ onClick, color, text = '' }: ModalControlProps) => {
  return (
    <BackButtonWrapper onClick={onClick}>
      <Icon name={isRtl() ? 'arrow-right' : 'arrow-left'} cdn width={32} height={32} fillColor={color} />
      {text}
    </BackButtonWrapper>
  );
};

export { CloseButton, BackButton };
